package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.AcupointName
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer

@Serializable
open class Acupoint(var id: String? = null){
	var name: AcupointName? = null
	var pinyin: String? = null
	var meridianId: String? = null
	var meridianName: String? = null
	var location: String? = null
	var imageUrl: String? = null
	var videoUrl: String? = null
	var indications: String? = null
	var operation: String? = null
	var experience: String? = null
	var prescription: String? = null
	var differentiation: String? = null
	var organizationId: String? = null
	var userId: String? = null
	var createdBy: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as Acupoint
		if (id != other.id) return false
		if (name != other.name) return false
		if (pinyin != other.pinyin) return false
		if (meridianId != other.meridianId) return false
		if (meridianName != other.meridianName) return false
		if (location != other.location) return false
		if (imageUrl != other.imageUrl) return false
		if (videoUrl != other.videoUrl) return false
		if (indications != other.indications) return false
		if (operation != other.operation) return false
		if (experience != other.experience) return false
		if (prescription != other.prescription) return false
		if (differentiation != other.differentiation) return false
		if (organizationId != other.organizationId) return false
		if (userId != other.userId) return false
		if (createdBy != other.createdBy) return false
		if (createdOn != other.createdOn) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (name?.hashCode() ?: 0)
		result = 31 * result + (pinyin?.hashCode() ?: 0)
		result = 31 * result + (meridianId?.hashCode() ?: 0)
		result = 31 * result + (meridianName?.hashCode() ?: 0)
		result = 31 * result + (location?.hashCode() ?: 0)
		result = 31 * result + (imageUrl?.hashCode() ?: 0)
		result = 31 * result + (videoUrl?.hashCode() ?: 0)
		result = 31 * result + (indications?.hashCode() ?: 0)
		result = 31 * result + (operation?.hashCode() ?: 0)
		result = 31 * result + (experience?.hashCode() ?: 0)
		result = 31 * result + (prescription?.hashCode() ?: 0)
		result = 31 * result + (differentiation?.hashCode() ?: 0)
		result = 31 * result + (organizationId?.hashCode() ?: 0)
		result = 31 * result + (userId?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		return result
	}

}
